import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import LocalStorage from '../../helpers/local-storage';
import Modal from '../modal';
import css from './index.scss';
import messages from './messages';
import Button from '../../components/button/index';
import { ROLLOVER_INFO_MODAL_OPTOUT } from '../../constants';

const InfoModal = ({ intl, show, handleOnSave }) => {
    const onDontTellAgainSelection = () => {
        const currentSelection = LocalStorage.getItem(ROLLOVER_INFO_MODAL_OPTOUT);

        if (!currentSelection) {
            LocalStorage.setItem(ROLLOVER_INFO_MODAL_OPTOUT, true);
        }
    };

    return (<Modal show={show} smallMode>
        <div className={css.infoModalWrapper}>
            <div className={css.title}>{intl.formatMessage(messages.queuedForRollover)}</div>
            <span className={css.content}>{`${intl.formatMessage(messages.whileYouMightSee)} `}
                <span className={css.contentBold}>{intl.formatMessage(messages.defaultCourse).toLowerCase()}</span>
                {`, ${intl.formatMessage(messages.changesWillNotTake)}`}</span>
            <div className={css.content}>{intl.formatMessage(messages.youMayChangeYour)}</div>
            <div className={css.checkbox}>
                <input name="dontTellAgain" onClick={onDontTellAgainSelection} type="checkbox" />
                <label htmlFor="dontTellAgain">{intl.formatMessage(messages.dontTellMeAgain)}</label>
            </div>
            <Button
                buttonContainer={css.iUnderstandButton}
                handleOnClick={handleOnSave}
                label={intl.formatMessage(messages.iUnderstand)}
            />
        </div>
    </Modal>);
};

InfoModal.propTypes = {
    handleOnSave: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(InfoModal));



// WEBPACK FOOTER //
// ./app/components/default-course-mapper-admin/information-modal.js